import Banner from "../components/Banner/Banner";
import Footer from "../components/Footer/Footer";
import Navigation from "../components/Navigation/Navigation";
import EditJobPost from "../components/PostJob/EditJobPost";
import Spinner from "../components/Spinner/Spinner";

function JobDetailEdit() {
  return (
    <div className="container-xxl bg-white p-0">
      <Spinner />
      <Navigation />
      <Banner pageName="Editing Job" />
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <EditJobPost />
      </div>
      <Footer />
    </div>
  );
}

export default JobDetailEdit;
